import SelectField from '@modules/formFields/SelectField'
import moment from 'moment'
import React, { Component } from 'react'
import { Button } from 'react-bootstrap'
import DropdownButton from 'react-bootstrap/es/DropdownButton'
import MenuItem from 'react-bootstrap/es/MenuItem'
import Modal from 'react-bootstrap/es/Modal'
import { Trans, withTranslation } from 'react-i18next'
import connect from 'react-redux/es/connect/connect'
import actionCreators from 'redux-form/es/actions'
import Customer from '@services/Customer'
import { history } from '@services/History'
import Consultations from '@services/Consultations'
import ElectronicPrescription from '@services/ElectronicPrescription'
import CoreV2 from '@services/CoreV2'
import uuid from 'uuid/v4'
import CustomModal from '@/adminv2/common/Modal/childrenModal'
import Select from 'react-select'
import { MeetingDoctorsAxiosHttpClientRepository, MicroServices, getNps, NpsParamsKeys } from '@meeting-doctors/api'
import { createNps } from '@/modules/nps/hooks/useNps'

const microServicesBaseUrls = {
  [MicroServices.VideoCall]: '',
  [MicroServices.Consultations]: import.meta.env.VITE_REACT_APP_URL_CONSULTATIONS,
  [MicroServices.Corev2]: import.meta.env.VITE_REACT_APP_URL_CORE_V2.slice(0, -1),
  [MicroServices.Customer]: import.meta.env.VITE_REACT_APP_URL_CUSTOMER.slice(0, -1),
}

const downloadSvg = (color) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 13V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V13" />
      <path
        d="M19 13V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V13"
        stroke={color ? color : 'white'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5 8L10 13L15 8" />
      <path
        d="M5 8L10 13L15 8"
        stroke={color ? color : 'white'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13V1"
        stroke={color ? color : 'white'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export class RoomHeader extends Component {
  roomClient = Consultations.adminRooms
  reportsClient = Consultations.reports
  derivationsClient = Consultations.derivations
  prescriptionClient = ElectronicPrescription.prescription
  npsClient = CoreV2.nps

  state = {
    ...this.props.room,
    showBanModal: false,
    showUnBanModal: false,
    showDocumentsDownloadModal: false,
    banReason: '',
    downloadDocumentType: '',
    prescriptions: null,
    selectedPrescriptions: [],
    reports: [],
    selectedReports: [],
    derivations: [],
    selectedDerivations: [],
  }

  getGender = (gender) => {
    if (!gender) return this.props.t('Género desconocido')
    if (gender === 0) return this.props.t('Hombre')
    if (gender === 1) return this.props.t('Mujer')
    return gender
  }

  /*TODO: if birthdate is string return Nan */
  getAge = (birthDate) => {
    if (!birthDate) return this.props.t('Edad desconocida')
    if (typeof birthDate === 'string')
      return `${moment().diff(moment(birthDate, 'DD-MM-YYYY'), 'years')} ${this.props.t('años')}`
    return `${moment().diff(birthDate, 'years')} ${this.props.t('años')}`
  }
  requestRating = async () => {
    try {
      const companyApiKey = this.state.api_key
      const customerHash = this.state.customer.hash
      const professionalHash = this.state.professional.hash
      const npsId = uuid()
      const roomId = this.state.id
      await createNps(
        {
          data: {
            attributes: {
              api_key: companyApiKey,
              should_notify: true,
            },
            id: npsId,
            relationships: {
              service: {
                data: {
                  type: 'room',
                  id: `${roomId}`,
                },
              },
            },
          },
        },
        {
          professionalHash,
          customerHash,
        }
      )
    } catch (error) {
      window.alert(JSON.stringify(error.message, null, 2))
    }
  }
  activateRoom = () => {
    this.roomClient
      .activateRoom(this.state.id)
      .then(() => this.setState({ is_active: true }))
      .catch((e) => window.alert(JSON.stringify(e.message, null, 2)))
  }
  deActivateRoom = () => {
    this.roomClient
      .deActivateRoom(this.state.id)
      .then(() => this.setState({ is_active: false }))
      .then(() => {
        CoreV2.updateHeaders({ apiKey: this.state.api_key })
        /* this.npsClient.sendNps(this.state.api_key, {
          id: uuid(),
          professional: this.state.professional.hash,
          customer: this.state.customer.hash,
          type: 'manual',
          service: '-',
        }) */
        return createNps(
          {
            data: {
              attributes: {
                api_key: this.state.api_key,
                should_notify: true,
              },
              id: uuid(),
              relationships: {
                service: {
                  data: {
                    type: 'manual',
                    id: '-',
                  },
                },
              },
            },
          },
          {
            professionalHash: this.state.professional.hash,
            customerHash: this.state.customer.hash,
          }
        )
      })
      .catch((e) => window.alert(JSON.stringify(e.message, null, 2)))
  }
  setNeedToRead = () => {
    this.roomClient
      .setRoomNeedToRead(this.state.id)
      .then(() => this.setState({ need_to_read: true }))
      .catch((e) => window.alert(JSON.stringify(e.message, null, 2)))
  }
  unSetNeedToRead = () => {
    this.roomClient
      .unSetRoomNeedToRead(this.state.id)
      .then(() => this.setState({ need_to_read: false }))
      .catch((e) => window.alert(JSON.stringify(e.message, null, 2)))
  }
  setNeedToAnswer = () => {
    this.roomClient
      .setRoomNeedToAnswer(this.state.id)
      .then(() => this.setState({ need_to_answer: true }))
      .catch((e) => window.alert(JSON.stringify(e.message, null, 2)))
  }
  unSetNeedToAnswer = () => {
    this.roomClient
      .unSetRoomNeedToAnswer(this.state.id)
      .then(() => this.setState({ need_to_answer: false }))
      .catch((e) => window.alert(JSON.stringify(e.message, null, 2)))
  }
  banUser = () => {
    const { room } = this.props
    Customer.adminRooms
      .banRoomCustomer(room, this.state.banReason)
      .then(() =>
        this.setState({
          showBanModal: false,
          customer: { ...this.state.customer, isBanned: true },
        })
      )
      .catch((e) => window.alert(JSON.stringify(e.message, null, 2)))
  }
  unBanUser = () => {
    const { room } = this.props

    Customer.adminRooms
      .unBanRoomCustomer(room)
      .then(() =>
        this.setState({
          showUnBanModal: false,
          customer: { ...this.state.customer, isBanned: false },
        })
      )
      .catch((e) => window.alert(JSON.stringify(e.message, null, 2)))
  }
  onClickRelatedRooms = () => {
    const {
      room: { customer },
      dispatch,
    } = this.props

    //TODO: SEE REDUX_FORM external change of form values
    dispatch(
      actionCreators.initialize('adminRoomFilters', {
        customerFilter: { ...customer, name: customer.firstname },
        startDate: moment(customer.created_at).toDate(),
        endDate: moment().toDate(),
        page: 1,
      })
    )

    history.push('/room')
  }
  setReports = () => {
    this.reportsClient
      .index({ customer_hash: this.state.customer.hash })
      .then((response) => {
        let formattedOptions = response.data.map((item) => ({
          value: item.id,
          label: 'MR_' + moment(item.created_at).format('YYYY-MM-DD_h-mm'),
          downloadLink: item.pdf_url,
        }))

        this.setState({
          reports: formattedOptions,
        })
      })
      .catch((e) => {
        console.log('Could not find any report')
      })
  }
  setDerivations = () => {
    this.derivationsClient
      .index({ customer_hash: this.state.customer.hash })
      .then((response) => {
        let formattedOptions = response.data.map((item) => ({
          value: item.id,
          label: 'MD_' + moment(item.created_at).format('YYYY-MM-DD_h-mm'),
          downloadLink: item.url,
        }))

        this.setState({
          derivations: formattedOptions,
        })
      })
      .catch((e) => {
        console.log('Could not find any derivation')
      })
  }
  setPrescriptions = () => {
    ElectronicPrescription.updateHeaders({
      ApiKey: this.state.company.api_key,
    })
    this.prescriptionClient
      .indexByCustomerToken(this.state.customer.token)
      .then((response) => {
        let prescription = response.data
        this.setState({
          prescription: prescription,
          downloadDocumentType: prescription && prescription.url ? 'prescription' : '',
        })
      })
      .catch((e) => {
        console.log('Could not find any prescription')
      })
  }

  downloadFiles = (filesArray) => {
    console.log(filesArray)
    filesArray.forEach((item) => {
      item.downloadLink && item.label
        ? this.download(item.downloadLink, item.label)
        : console.log('Unable to find download link')
    })
  }

  download(url, filename) {
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = filename
        link.click()
      })
      .catch(console.error)
  }

  componentDidMount() {
    return Customer.adminRooms
      .fetchRoomCustomer(this.state) //TODO: add call by customerHash
      .then((res) =>
        this.setState({
          customer: {
            ...res.data.userData,
            isBanned: !!res.data.userData.banned,
          },
        })
      )
      .then(() => {
        this.setReports()
        this.setDerivations()
        this.setPrescriptions()
      })
      .catch((err) => {
        window.alert(JSON.stringify(err.message, null, 2))
      })
  }

  render() {
    const { room, t } = this.props
    const {
      customer,
      is_active,
      need_to_read,
      need_to_answer,
      pendingMessages,
      is_editable,
      downloadDocumentType,
      prescription,
      derivations,
      reports,
      selectedDerivations,
      selectedReports,
    } = this.state

    const documentDownloadComponent = (options, selectedOptions, selectionHandler, buttonHandler) => (
      <div className="documentDownload-content">
        <div className="documentDownload-select">
          <Select options={options} isMulti onChange={selectionHandler} value={selectedOptions} />
        </div>
        <button disabled={selectedOptions.length === 0} className="download-button" onClick={buttonHandler}>
          {downloadSvg(selectedOptions.length > 0 ? '#01A8E7' : '#999999')}
        </button>
      </div>
    )

    return (
      <>
        <div className="room-chat-header">
          <span> {`${this.getGender(customer.gender)} - ${this.getAge(customer.birthDate)}`}</span>

          {customer.isBanned && (
            <span style={{ color: 'red' }}>
              {' '}
              <Trans>Baneado</Trans>{' '}
            </span>
          )}
          {is_active && (
            <span style={{ color: '#00d2ff' }}>
              {' '}
              <Trans>Room activa</Trans>{' '}
            </span>
          )}
          {pendingMessages !== 0 && <div className={`badge-chat unread`}>{room.pendingMessages}</div>}
          {need_to_read && <i className="fas fa-eye" style={{ color: '#ffa900' }} />}
          {need_to_answer && <i className="fas fa-question" style={{ color: '#ffa900' }} />}
          {!!room.customer.vip && <i style={{ color: '#ffa900' }} className="far fa-star" />}

          <span className="room-header-company">{room.company.name}</span>

          <button
            id="documentsDownloadButton"
            className="documentsDownload_button"
            onClick={() => this.setState({ showDocumentsDownloadModal: true })}
          >
            {t('documentsDownload')}
            {downloadSvg()}
          </button>

          {is_editable && (
            <DropdownButton
              id="headerActions"
              bsStyle={'primary'}
              className={'btn-primary'}
              title={t('Acciones')}
              pullRight
            >
              <MenuItem onSelect={this.activateRoom} disabled={is_active}>
                <Trans>Activar chat</Trans>
              </MenuItem>
              <MenuItem onSelect={this.deActivateRoom} disabled={!is_active}>
                <Trans>Desactivar chat</Trans>
              </MenuItem>

              <MenuItem divider />

              <MenuItem onSelect={this.setNeedToRead} disabled={need_to_read}>
                <Trans>Marcar para leer</Trans>
              </MenuItem>
              <MenuItem onSelect={this.unSetNeedToRead} disabled={!need_to_read}>
                <Trans>Marcar como leido</Trans>
              </MenuItem>

              <MenuItem divider />

              <MenuItem onSelect={() => this.setState({ showBanModal: true })} disabled={this.state.customer.isBanned}>
                <Trans>Banear usuario</Trans>
              </MenuItem>
              <MenuItem
                onSelect={() => this.setState({ showUnBanModal: true })}
                disabled={!this.state.customer.isBanned}
              >
                <Trans>Desbanear usuario</Trans>
              </MenuItem>
              <MenuItem divider />

              <MenuItem onSelect={this.onClickRelatedRooms}>
                <Trans>Rooms relacionadas</Trans>
              </MenuItem>
              <MenuItem divider />

              <MenuItem onSelect={this.requestRating}>
                <Trans>Solicitar valoración</Trans>
              </MenuItem>
            </DropdownButton>
          )}
        </div>

        {this.state.showDocumentsDownloadModal && (
          <CustomModal close={() => this.setState({ showDocumentsDownloadModal: false })}>
            <div className="downloadDocumentModal">
              <div className="header">
                <span>{t('chooseDownloadDocument')}</span>
              </div>
              <div className="modal-content-document-download">
                <div className="checkboxContainer">
                  <input
                    type="radio"
                    id="prescription"
                    name="documentyType"
                    value="prescription"
                    checked={downloadDocumentType === 'prescription'}
                    onChange={() => this.setState({ downloadDocumentType: 'prescription' })}
                    disabled={!(prescription && prescription.url)}
                  />
                  <label htmlFor="prescription">{t('prescription')}</label>
                </div>
                <div className="checkboxContainer">
                  <input
                    type="radio"
                    id="report"
                    name="documentyType"
                    value="report"
                    checked={downloadDocumentType === 'report'}
                    onChange={() => this.setState({ downloadDocumentType: 'report' })}
                    disabled={reports.length === 0}
                  />
                  <label htmlFor="report">{t('reports')}</label>
                </div>
                <div className="checkboxContainer">
                  <input
                    type="radio"
                    id="derivation"
                    name="documentyType"
                    value="derivation"
                    checked={downloadDocumentType === 'derivation'}
                    onChange={() => this.setState({ downloadDocumentType: 'derivation' })}
                    disabled={derivations.length === 0}
                  />
                  <label htmlFor="derivation">{t('derivations')}</label>
                </div>
              </div>
              <hr className="solid" />
              {downloadDocumentType === 'prescription' && (
                <div className="prescriptionInfo">
                  <span className="prescriptionInfo_title">{t('prescription')}</span>
                  <span className="prescriptionInfo_date">
                    {moment(prescription.last_modified_at).format('DD/MM/YYYY')}
                  </span>
                  <span className="prescriptionInfo_name">{`${customer.firstName} ${customer.lastName}`}</span>
                  <div className="prescriptionInfo_downloadButton">
                    <button
                      disabled={!prescription}
                      className="download-button"
                      onClick={() =>
                        prescription &&
                        this.download(
                          prescription.url,
                          'MDP_' + moment(prescription.last_modified_at).format('DD/MM/YYYY')
                        )
                      }
                    >
                      {downloadSvg('#01A8E7')}
                    </button>
                  </div>
                </div>
              )}
              {downloadDocumentType === 'report' &&
                documentDownloadComponent(
                  reports,
                  selectedReports,
                  (options) => this.setState({ selectedReports: options }),
                  () => this.downloadFiles(selectedReports)
                )}
              {downloadDocumentType === 'derivation' &&
                documentDownloadComponent(
                  derivations,
                  selectedDerivations,
                  (options) => this.setState({ selectedDerivations: options }),
                  () => this.downloadFiles(selectedDerivations)
                )}
            </div>
          </CustomModal>
        )}

        {this.state.showBanModal && (
          <Modal show={true} onHide={() => this.setState({ showBanModal: false })}>
            <Modal.Header closeButton>
              <Modal.Title>
                <Trans>¿Estás seguro/a que quieres banear a este usuario?</Trans>{' '}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <SelectField
                simpleValue
                input={{
                  value: this.state.banReason,
                  onChange: (reason) => this.setState({ banReason: reason }),
                }}
                options={[
                  {
                    name: 'El usuario es menor de edad.',
                    id: 'El usuario es menor de edad.',
                  },
                  {
                    name: 'Falta de respeto al profesional.',
                    id: 'Falta de respeto al profesional.',
                  },
                  {
                    name: 'Mal uso del servicio.',
                    id: 'Mal uso del servicio.',
                  },
                ]}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button bsStyle="primary" onClick={this.banUser}>
                <Trans>Banear</Trans>
              </Button>
            </Modal.Footer>
          </Modal>
        )}

        {this.state.showUnBanModal && (
          <Modal show={true} onHide={() => this.setState({ showUnBanModal: false })}>
            <Modal.Header closeButton>
              <Modal.Title>
                <Trans>¿Estás seguro/a que quieres desbanear a este usuario?</Trans>{' '}
              </Modal.Title>
            </Modal.Header>
            <Modal.Footer>
              <Button bsStyle="primary" onClick={this.unBanUser}>
                <Trans>Desbanear</Trans>
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  isSuperAdmin: state.auth.isSuperAdmin,
})

export default connect(mapStateToProps)(withTranslation()(RoomHeader))
